import {OctTable} from "@oceantech/oceantech-ui";
import {Modal} from "react-bootstrap";
import {textSystem} from "../../utils/Constant";
import {RESULT} from "../constants/CorrectiveSubsectionModal";
import moment from "moment";
import {useContext, useState} from "react";
import {IFile, IViewFile} from "../../models/models";
import {handleViewFileUtil, handleDownloadFileUtil} from "../../utils/FileUtils";
import {AppContext} from "../../appContext/AppContext";
import ViewFile from "../modals/ViewFile";
import {FileBtnGroup} from "../components/FileBtnGroup";

type Props = {
  show: boolean;
  handleCloseDialog: () => void;
  dataTableDetailRow: any;
};

const EvaluateDetailsModal = (props: Props) => {
  const {show, handleCloseDialog, dataTableDetailRow} = props;
  const {setIsLoading} = useContext(AppContext);
  const [viewFile, setViewFile] = useState<IViewFile>({
    open: false,
    file: null,
  });

  const handleViewFile = async (file: IFile) => {
    const viewFile = await handleViewFileUtil(file, setIsLoading);
    if (viewFile) {
      setViewFile(viewFile);
    }
  };

  const handleDownloadFile = async (file: IFile) => {
    await handleDownloadFileUtil(file, setIsLoading);
  };

  const criteriaDetailColumns = [
    {
      name: "Ngày cập nhật",
      field: "modifiedDate",
      headerStyle: {
        width: "200px",
      },
      cellStyle: {
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {row?.modifiedDate
            ? moment(row?.modifiedDate).format("DD/MM/YYYY HH:mm:ss")
            : ""}
        </div>
      ),
    },
    {
      name: "Nhân viên tự đánh giá",
      field: "pointSelfAssessment",
      cellStyle: {
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          <span>
            {RESULT.find(
              (result: any) => result.id === row?.pointSelfAssessment
            )?.name || ""}
          </span>
        </div>
      ),
    },
    {
      name: "Bằng chứng",
      field: "fileName",
      cellStyle: {
        width: "200px",
        minWidth: "200px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex align-items-center justify-content-center">
          <label className="custom-file-upload">
            <span className="text-info">{row?.fileName}</span>
          </label>
          {row?.fileName && (
            <FileBtnGroup
              file={{id: row?.fileId, name: row?.fileName}}
              onView={handleViewFile}
              onDownload={handleDownloadFile}
            />
          )}
        </div>
      ),
    },
    {
      name: "Kết luận",
      field: "conclusionAssessment",
      cellStyle: {
        minWidth: "110px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          <span>
            {RESULT.find(
              (result: any) => result.id === row?.conclusionAssessment
            )?.name || ""}
          </span>
        </div>
      ),
    },
    {
      name: "Ghi chú người đánh giá",
      field: "comment",
      cellStyle: {
        minWidth: "110px",
        ...textSystem,
      },
    },
  ];

  return (
    <Modal show={show} onHide={handleCloseDialog} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Chi tiết đánh giá</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <OctTable
          id="searchCriteriaDetailRow"
          className={`table-background-th spaces `}
          data={dataTableDetailRow}
          columns={criteriaDetailColumns}
          fixedColumnsCount={-1}
          noToolbar={true}
          // handleDoubleClick={handleDoubleClick}
          clearToolbar={true}
          // type={TYPE.MULTILINE}
          // setDataChecked={(dataChecked) => setDataChecked(dataChecked)}
          noPagination={true}
        />
      </Modal.Body>
      {viewFile?.open && (
        <ViewFile
          show={viewFile?.open}
          file={viewFile?.file}
          onHide={() => setViewFile({open: false, file: null})}
        />
      )}
    </Modal>
  );
};

export default EvaluateDetailsModal;
